import React from "react";

const FVFRDeliveryZones = ({ title, description, zones }) => {
  return (
    <section className="fvfr-zones-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div
          className="table-responsive"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="fvfr-zones-table">
            <thead>
              <tr>
                <th>Dubai Delivery Zones</th>
                <th>Sharjah Delivery Zones</th>
              </tr>
            </thead>
            <tbody>
              {zones.map((zone, i) => (
                <tr key={i}>
                  <td>{zone.dubai}</td>
                  <td>{zone.sharjah}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default FVFRDeliveryZones;
